module.exports = __webpack_public_path__ + "media/images/admin/logo-87512a411d5d5798bd4dc5cb62ecc901.png";